module.exports = __webpack_public_path__ + "img/exterior_8.0a19d15c.jpg";